import React, { useMemo } from "react";

function Dashboard({ rows }) {

  const { totalDoanhThu, totalDaChuyen, totalThieu, missingCount, keToanNhapTruoc } = useMemo(() => {
    let totalDoanhThu = 0;
    let totalDaChuyen = 0;
    let totalThieu = 0;
    let missingCount = 0;
    let keToanNhapTruoc = 0;

    rows.forEach((row) => {
      // Kiểm tra doanh thu
      const hasDoanhThu = row.doanhThu && row.doanhThu > 0;
      const doanhThuValue = hasDoanhThu ? (typeof row.doanhThu === 'number' ? row.doanhThu : Number(row.doanhThu) || 0) : 0;

      // Kiểm tra kế toán nhập
      const hasKeToan = row.keToanChuyen !== '' && row.keToanChuyen !== null && row.keToanChuyen !== undefined;
      const keToanValue = hasKeToan ? (typeof row.keToanChuyen === 'number' ? row.keToanChuyen : Number(row.keToanChuyen) || 0) : 0;

      // Tổng doanh thu (tổng tất cả cột doanh thu)
      if (hasDoanhThu) {
        totalDoanhThu += doanhThuValue;
      }

      // Tổng đã chuyển (tổng giá trị kế toán nhập mà có giá trị ở cột doanh thu)
      if (hasDoanhThu && hasKeToan) {
        totalDaChuyen += keToanValue;
      }

      // Tổng thiếu: tổng (doanh thu - kế toán nhập) cho các dòng có doanh thu > kế toán nhập
      if (hasDoanhThu) {
        const thieu = doanhThuValue - keToanValue;
        if (thieu > 0) {
          totalThieu += thieu;
        }
      }

      // Số lái xe chưa chuyển: có doanh thu nhưng chưa có kế toán nhập
      if (hasDoanhThu && !hasKeToan) {
        missingCount += 1;
      }

      // Kế toán nhập trước: có kế toán nhập nhưng chưa có doanh thu
      if (hasKeToan && !hasDoanhThu) {
        keToanNhapTruoc += keToanValue;
      }
    });

    return { totalDoanhThu, totalDaChuyen, totalThieu, missingCount, keToanNhapTruoc };
  }, [rows]);

  return (
    <div className="mb-6 sm:mb-8">
      <h1 className="text-lg sm:text-xl md:text-2xl font-semibold text-slate-900 mb-3 sm:mb-4">
        Điều phối doanh thu xe
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-3 sm:p-4">
          <p className="text-xs sm:text-sm text-slate-500 mb-1">
            Doanh thu
          </p>
          <p className="text-lg sm:text-xl md:text-2xl font-semibold text-slate-900 break-words">
            {totalDoanhThu.toLocaleString("vi-VN")} đ
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-3 sm:p-4">
          <p className="text-xs sm:text-sm text-slate-500 mb-1">
            Đã chuyển
          </p>
          <p className="text-lg sm:text-xl md:text-2xl font-semibold text-emerald-600 break-words">
            {totalDaChuyen.toLocaleString("vi-VN")} đ
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-3 sm:p-4">
          <p className="text-xs sm:text-sm text-slate-500 mb-1">
            Thiếu
          </p>
          <p className="text-lg sm:text-xl md:text-2xl font-semibold text-rose-600 break-words">
            {totalThieu.toLocaleString("vi-VN")} đ
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-3 sm:p-4">
          <p className="text-xs sm:text-sm text-slate-500 mb-1">
            Số lái xe chưa chuyển
          </p>
          <p className="text-lg sm:text-xl md:text-2xl font-semibold text-amber-600">
            {missingCount}
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-3 sm:p-4">
          <p className="text-xs sm:text-sm text-slate-500 mb-1">
            Kế toán nhập trước
          </p>
          <p className="text-lg sm:text-xl md:text-2xl font-semibold text-blue-600 break-words">
            {keToanNhapTruoc.toLocaleString("vi-VN")} đ
          </p>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;

